import { SettingConst } from '@faire/web-api--source/types';

/**
 * Determines whether a customer gets VIP support in the Help Center
 */
export const HELP_CENTER_VIP_SUPPORT_250422 =
  'HELP_CENTER_VIP_SUPPORT_250422' as SettingConst<
    'HELP_CENTER_VIP_SUPPORT_250422',
    boolean,
    'RETAILER' | 'RETAILER_IOS' | 'RETAILER_ANDROID'
  >;
